/**
 * Polling intervals, retry limits, and timeout configuration
 * for async job tracking and SSE streaming.
 */

export const POLLING = {
  /** Smart Column job polling interval (ms) */
  SMART_COLUMN_INTERVAL_MS: 3000,
  /** Smart Match job polling interval (ms) */
  SMART_MATCH_INTERVAL_MS: 3000,
  /** Pivot Table Column job polling interval (ms) */
  PIVOT_TABLE_INTERVAL_MS: 3000,

  /** SSE connection max retry attempts */
  SSE_MAX_RETRIES: 3,
  /** SSE connection retry delay (ms) */
  SSE_RETRY_DELAY_MS: 1000,

  /** Token refresh check interval in App.tsx (ms) */
  TOKEN_CHECK_INTERVAL_MS: 400,

  /** Navigation delay after filter page redirect (ms) */
  NAVIGATION_DELAY_MS: 2000,
} as const;
